module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('checkbox', {
    staticClass: "my-2",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.priceIncludeTaxesChanged
    },
    model: {
      value: (_vm.prices[0].isTaxIncludedInPrice),
      callback: function($$v) {
        _vm.$set(_vm.prices[0], "isTaxIncludedInPrice", $$v)
      },
      expression: "prices[0].isTaxIncludedInPrice"
    }
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("\n                    Price include taxes.\n                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.types) ? _c('v-select', {
    attrs: {
      "serpa": "",
      "options": _vm.types,
      "label": "description",
      "placeholder": "- Select type -",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.updateType(_vm.selectedPrincingType)
      }
    },
    model: {
      value: (_vm.selectedPrincingType),
      callback: function($$v) {
        _vm.selectedPrincingType = $$v
      },
      expression: "selectedPrincingType"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedPrincingType && _vm.selectedPrincingType.id == 1) ? _c('div', {
    staticClass: "col-sm-12 mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")]), _vm._v(" "), (_vm.prices[0].productGenderPriceComponents && _vm.prices[0].productGenderPriceComponents.length > 0) ? _c('input', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.customPerPersonTaxes(_vm.prices[0].productGenderPriceComponents)
    }
  }) : (_vm.taxes) ? _c('v-select', {
    attrs: {
      "options": _vm.taxes,
      "label": "description",
      "placeholder": "- Select tax -",
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.updateTaxType(_vm.prices[0], _vm.prices[0].vatTypeHelper)
      }
    },
    model: {
      value: (_vm.prices[0].vatTypeHelper),
      callback: function($$v) {
        _vm.$set(_vm.prices[0], "vatTypeHelper", $$v)
      },
      expression: "prices[0].vatTypeHelper"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.perOrderReferenceGenderPrice) ? _c('div', {}, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [(_vm.perOrderReferenceGenderPrice.productGenderPriceComponents && _vm.perOrderReferenceGenderPrice.productGenderPriceComponents.length > 0) ? _c('input', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.customPerPersonTotal(_vm.perOrderReferenceGenderPrice.productGenderPriceComponents) + ' €'
    }
  }) : _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prices[0].value),
      expression: "prices[0].value"
    }],
    staticClass: "glued-right",
    staticStyle: {
      "width": "4rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "number"
    },
    domProps: {
      "value": (_vm.prices[0].value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prices[0], "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("€")])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Edit'),
      expression: "'Edit'"
    }],
    staticClass: "fas fa-calculator fs-large medium ml-3",
    class: {
      'pointer': !_vm.disabled, 'notAllowed': _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.openEditPrice(_vm.perOrderReferenceGenderPrice)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-3"
  }, [_c('div', {
    staticClass: "pricesRowHolder"
  }, _vm._l((_vm.prices), function(pricePerPerson, index) {
    return (pricePerPerson.isExcludedFromBilling) ? _c('div', {
      staticClass: "mt-2 mb-3 pb-3 border-bottom-medium"
    }, [_c('price-manager-row', {
      attrs: {
        "disabled": _vm.disabled,
        "pricePerPerson": pricePerPerson,
        "pricePerOrder": true,
        "audienceTypes": _vm.genderPricesAvailableOptions
      },
      on: {
        "delete": function($event) {
          return _vm.deletePrincingType(index)
        }
      }
    })], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "add d-flex align-items-center fs-small bold",
    class: {
      'pointer': !_vm.disabled, 'notAllowed': _vm.disabled
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add participant\n                            ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedPrincingType && _vm.selectedPrincingType.id == 2) ? _c('div', {
    staticClass: "col-sm-12 mt-3"
  }, [_c('div', {
    staticClass: "pricesRowHolder"
  }, _vm._l((_vm.prices), function(pricePerPerson, index) {
    return _c('div', {
      staticClass: "mt-2 mb-3 pb-3 border-bottom-medium"
    }, [_c('price-manager-row', {
      attrs: {
        "pricePerPerson": pricePerPerson,
        "disabled": _vm.disabled,
        "showDelete": _vm.prices.length > 1,
        "audienceTypes": _vm.genderPricesAvailableOptions
      },
      on: {
        "delete": function($event) {
          return _vm.deletePrincingType(index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "add d-flex align-items-center fs-small bold",
    class: {
      'pointer': !_vm.disabled, 'notAllowed': _vm.disabled
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new price\n                    ")])])])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0015c2fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0015c2fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/PricingManager.vue
// module id = 956
// module chunks = 0